import axios from "axios";

import { reportApiDomain, harisChannelKey } from "../utils/Constants";

const http = new axios.create({
  baseURL: reportApiDomain,
});

const httpMethod = {
  get(url, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      Authorization: `Bearer ${accessToken}`,
      "Channel-Key": harisChannelKey,
    };
    return http
      .get(url, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        return data;
      });
  },
  post(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      Authorization: `Bearer ${accessToken}`,
      "Channel-Key": harisChannelKey,
    };
    return http
      .post(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.success) {
          return Promise.reject(data.error);
        }
        return data;
      });
  },
  upload(url, formData = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "multipart/form-data",
      "Channel-Key": harisChannelKey,
    };
    return http
      .post(url, formData, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.success) {
          return Promise.reject(data.error);
        }

        return data;
      });
  },
  create(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      Authorization: `Bearer ${accessToken}`,
      "Channel-Key": harisChannelKey,
    };

    return http
      .post(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.success) {
          return Promise.reject(data.error);
        }

        return data;
      });
  },
  put(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      Authorization: `Bearer ${accessToken}`,
      "Channel-Key": harisChannelKey,
    };

    return http
      .put(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.success) {
          return Promise.reject(data.error);
        }

        return data;
      });
  },
  delete(url, data = null, options = {}) {
    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    let header = {
      Authorization: `Bearer ${accessToken}`,
      "Channel-Key": harisChannelKey,
    };
    return http
      .delete(url, data, {
        ...options,
        headers: {
          ...header,
          ...options.headers,
        },
      })
      .then((res) => res.data)
      .then((data) => {
        if (!data.success) {
          return Promise.reject(data.error);
        }

        return data;
      });
  },
};
export default httpMethod;
